// extracted by mini-css-extract-plugin
export var chip = "_38-9";
export var chipLabel = "_38-a";
export var close = "_38-7";
export var closeIcon = "_38-8";
export var error = "_38-6";
export var infoTooltip = "_38-2";
export var innerContainer = "_38-1";
export var input = "_38-b";
export var medium = "_38-5";
export var outerContainer = "_38-0";
export var small = "_38-4";
export var xSmall = "_38-3";